import { render, staticRenderFns } from "./bulkUniformIndent.vue?vue&type=template&id=1f67ae2a&scoped=true"
import script from "./bulkUniformIndent.vue?vue&type=script&lang=js"
export * from "./bulkUniformIndent.vue?vue&type=script&lang=js"
import style0 from "./bulkUniformIndent.vue?vue&type=style&index=0&id=1f67ae2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67ae2a",
  null
  
)

export default component.exports